import script from "./GalleryFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./GalleryFooter.vue?vue&type=script&lang=ts&setup=true"

import "./GalleryFooter.vue?vue&type=style&index=0&id=b94a1b9e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b94a1b9e"]])

export default __exports__